// SPA entry point (ADR-017). Replaces `app/layout.tsx`, which supplied the
// document shell, fonts, and providers under Next. The shell now lives in
// `index.html`; the rest is here.

import * as React from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";

// Self-hosted fonts, bundled rather than fetched from Google. `next/font/google`
// did the same at build time; keeping that property matters because the
// distribution should not make third-party requests for an authenticated
// console. Wired to Tailwind through the CSS variables set in globals.css.
import "@fontsource-variable/ibm-plex-sans";
import "@fontsource-variable/jetbrains-mono";

import { Toaster } from "@/components/ui/toaster";
import { Providers } from "@/app/providers";
import { router } from "@/routes";
import "@/app/globals.css";

const container = document.getElementById("root");
if (!container) throw new Error("#root missing from index.html");

createRoot(container).render(
  <React.StrictMode>
    <Providers>
      <RouterProvider router={router} />
      <Toaster />
    </Providers>
  </React.StrictMode>,
);
